// Minimal Lottie-compatible JSON animation data for empty states
// These are lightweight inline animations so we don't need external files

export const searchEmptyAnimation = {
  v: "5.7.1", fr: 30, ip: 0, op: 90, w: 200, h: 200,
  layers: [{
    ty: 4, nm: "circle", ip: 0, op: 90, st: 0,
    ks: {
      o: { a: 1, k: [{ t: 0, s: [40] }, { t: 45, s: [80] }, { t: 90, s: [40] }] },
      r: { a: 0, k: 0 }, p: { a: 0, k: [100, 100] }, s: { a: 1, k: [{ t: 0, s: [90, 90] }, { t: 45, s: [110, 110] }, { t: 90, s: [90, 90] }] }
    },
    shapes: [{
      ty: "el", p: { a: 0, k: [0, 0] }, s: { a: 0, k: [80, 80] }
    }, {
      ty: "st", c: { a: 0, k: [0.388, 0.4, 0.945, 1] }, w: { a: 0, k: 3 }, o: { a: 0, k: 100 }
    }, {
      ty: "fl", c: { a: 0, k: [0.388, 0.4, 0.945, 0.1] }, o: { a: 0, k: 100 }
    }]
  }, {
    ty: 4, nm: "handle", ip: 0, op: 90, st: 0,
    ks: {
      o: { a: 1, k: [{ t: 0, s: [40] }, { t: 45, s: [80] }, { t: 90, s: [40] }] },
      r: { a: 1, k: [{ t: 0, s: [0] }, { t: 45, s: [15] }, { t: 90, s: [0] }] },
      p: { a: 0, k: [125, 125] }, s: { a: 0, k: [100, 100] }
    },
    shapes: [{
      ty: "rc", p: { a: 0, k: [0, 15] }, s: { a: 0, k: [6, 35] }, r: { a: 0, k: 3 }
    }, {
      ty: "fl", c: { a: 0, k: [0.388, 0.4, 0.945, 1] }, o: { a: 0, k: 100 }
    }]
  }]
};

export const sleepAnimation = {
  v: "5.7.1", fr: 30, ip: 0, op: 120, w: 200, h: 200,
  layers: [{
    ty: 4, nm: "z1", ip: 0, op: 120, st: 0,
    ks: {
      o: { a: 1, k: [{ t: 0, s: [0] }, { t: 20, s: [80] }, { t: 80, s: [80] }, { t: 120, s: [0] }] },
      p: { a: 1, k: [{ t: 0, s: [90, 110] }, { t: 120, s: [70, 60] }] },
      s: { a: 1, k: [{ t: 0, s: [60, 60] }, { t: 60, s: [100, 100] }, { t: 120, s: [60, 60] }] },
      r: { a: 1, k: [{ t: 0, s: [0] }, { t: 120, s: [-20] }] }
    },
    shapes: [{
      ty: "gr",
      it: [
        { ty: "rc", p: { a: 0, k: [0, 0] }, s: { a: 0, k: [24, 24] }, r: { a: 0, k: 4 } },
        { ty: "fl", c: { a: 0, k: [0.388, 0.4, 0.945, 1] }, o: { a: 0, k: 100 } },
        { ty: "tr", p: { a: 0, k: [0, 0] }, s: { a: 0, k: [100, 100] } }
      ]
    }]
  }, {
    ty: 4, nm: "z2", ip: 20, op: 120, st: 20,
    ks: {
      o: { a: 1, k: [{ t: 20, s: [0] }, { t: 40, s: [60] }, { t: 90, s: [60] }, { t: 120, s: [0] }] },
      p: { a: 1, k: [{ t: 20, s: [105, 100] }, { t: 120, s: [90, 55] }] },
      s: { a: 1, k: [{ t: 20, s: [40, 40] }, { t: 70, s: [80, 80] }, { t: 120, s: [40, 40] }] },
      r: { a: 1, k: [{ t: 20, s: [0] }, { t: 120, s: [15] }] }
    },
    shapes: [{
      ty: "gr",
      it: [
        { ty: "rc", p: { a: 0, k: [0, 0] }, s: { a: 0, k: [18, 18] }, r: { a: 0, k: 3 } },
        { ty: "fl", c: { a: 0, k: [0.533, 0.545, 0.969, 1] }, o: { a: 0, k: 100 } },
        { ty: "tr", p: { a: 0, k: [0, 0] }, s: { a: 0, k: [100, 100] } }
      ]
    }]
  }, {
    ty: 4, nm: "moon", ip: 0, op: 120, st: 0,
    ks: {
      o: { a: 0, k: 30 },
      p: { a: 0, k: [110, 90] },
      s: { a: 1, k: [{ t: 0, s: [95, 95] }, { t: 60, s: [105, 105] }, { t: 120, s: [95, 95] }] }
    },
    shapes: [{
      ty: "el", p: { a: 0, k: [0, 0] }, s: { a: 0, k: [60, 60] }
    }, {
      ty: "fl", c: { a: 0, k: [0.945, 0.753, 0.275, 1] }, o: { a: 0, k: 100 }
    }]
  }]
};

export const rocketAnimation = {
  v: "5.7.1", fr: 30, ip: 0, op: 90, w: 200, h: 200,
  layers: [{
    ty: 4, nm: "body", ip: 0, op: 90, st: 0,
    ks: {
      o: { a: 0, k: 100 },
      p: { a: 1, k: [{ t: 0, s: [100, 110] }, { t: 45, s: [100, 90] }, { t: 90, s: [100, 110] }] },
      r: { a: 0, k: -30 },
      s: { a: 0, k: [100, 100] }
    },
    shapes: [{
      ty: "rc", p: { a: 0, k: [0, 0] }, s: { a: 0, k: [20, 45] }, r: { a: 0, k: 10 }
    }, {
      ty: "fl", c: { a: 0, k: [0.388, 0.4, 0.945, 1] }, o: { a: 0, k: 100 }
    }]
  }, {
    ty: 4, nm: "flame", ip: 0, op: 90, st: 0,
    ks: {
      o: { a: 1, k: [{ t: 0, s: [60] }, { t: 15, s: [100] }, { t: 30, s: [60] }, { t: 45, s: [100] }, { t: 60, s: [60] }, { t: 75, s: [100] }, { t: 90, s: [60] }] },
      p: { a: 1, k: [{ t: 0, s: [110, 130] }, { t: 45, s: [110, 110] }, { t: 90, s: [110, 130] }] },
      r: { a: 0, k: -30 },
      s: { a: 1, k: [{ t: 0, s: [80, 80] }, { t: 22, s: [120, 120] }, { t: 45, s: [80, 80] }, { t: 67, s: [120, 120] }, { t: 90, s: [80, 80] }] }
    },
    shapes: [{
      ty: "el", p: { a: 0, k: [0, 5] }, s: { a: 0, k: [14, 20] }
    }, {
      ty: "fl", c: { a: 0, k: [0.976, 0.612, 0.125, 1] }, o: { a: 0, k: 100 }
    }]
  }]
};
